<template>
  <v-layout row justify-center>
    <v-dialog
      v-if="servicesList.length"
      persistent
      scrollable
      @keydown.esc="close"
      v-model="getEditCrewDialog"
      max-width="700px"
    >
      <v-flex xs12 align-center justify-space-between>
      <v-card>
        <v-card-text style="height: 300px;">
          <h3>{{ approvedTitleLabel }}</h3>
          <v-select
            :disabled="isPreplan"
            :items="servicesList | filterPalBearers"
            v-model="selectedPallbearersEvent"
            item-text="description"
            v-on:input="limiter"
            attach
            chips
            clearable
            multiple
            label="Select pallbearers"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
          <h3>Select Crew for the funeral</h3>
          <v-select
            :disabled="isPreplan"
            :items="servicesList | filterPalBearers(1)"
            v-model="selectedPallbearersClosing"
            item-text="description"
            v-on:input="limiter"
            attach
            chips
            clearable
            multiple
            label="Select pallbearers"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
        <v-snackbar
          v-model="snackbar"
          color="#ff5353"
          multi-line
          top
          right
          :timeout=6000
        >
          You can select no more than three
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>

        </v-card-text>
        <v-card-actions justify-center>
          <v-spacer></v-spacer>
          <v-btn
            color="gray darken-1"
            flat
            @click="close"
          >Close</v-btn>
          <v-btn
            :disabled="!selectedPallbearersEvent.length || !selectedPallbearersClosing.length"
            color="green darken-1"
            flat
            @click.native="submit"
          >{{ approvedBtnLabel }}Select & Notify</v-btn>
        </v-card-actions>
      </v-card>
      </v-flex>
    </v-dialog>
  </v-layout>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import schedulesAPI from '@/api/resources/schedules'
  import AddLeadFormOld from '@/components/AddLeadFormOld'
  import { mapGetters } from 'vuex'

  export default {
    components: { AddLeadFormOld },
    computed: {
      ...mapGetters({
        getEditCrewDialog: 'getEditCrewDialog',
        getEditCrewCaseId: 'getEditCrewCaseId',
        caseById: 'getCaseById',
        servicesList: 'allServices'
      }),
      approved () {
        return this.caseById(this.getEditCrewCaseId).status === 'approved'
      },
      approvedBtnLabel () {
        if (!this.approved) return 'Approve Case, '
        return ''
      },
      approvedTitleLabel () {
        return !this.approved ? 'Crew for sending' : 'Crew for funeral'
      }
    },
    data () {
      return {
        selectedPallbearersEvent: [],
        selectedPallbearersClosing: [],
        snackbar: false,
        isPreplan: false,
        leadsUuid: null
      }
    },
    filters: {
      filterPalBearers (value, closing) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew'
          : false
        )
      }
    },
    watch: {
      isPreplan (v) {
        if (v !== this.caseById(this.getEditCrewCaseId).is_preplan) this.$store.dispatch('updateCase', {case_id: this.getEditCrewCaseId, payload: { is_preplan: this.isPreplan }})
        if (v) {
          this.selectedPallbearersEvent = []
          this.selectedPallbearersClosing = []
        }
      },
      getEditCrewCaseId (v) {
        this.isPreplan = this.caseById(this.getEditCrewCaseId).is_preplan
        casesAPI.getLead(this.getEditCrewCaseId).then(result => {
          this.leadsUuid = result[0].leads_id
          this.selectedPallbearersEvent = result
            .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 0)
            .map(item => { return item.item_id })
          this.selectedPallbearersClosing = result
            .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 1)
            .map(item => { return item.item_id })
        }, () => {})
      }
    },
    methods: {
      limiter (e) {
        if (e.length > 999) {
          this.snackbar = true
          e.pop()
        }
      },
      close () {
        this.$store.commit('switchCrewDialog')
      },
      async selectEventCrew () {
        try {
          const response = await schedulesAPI.updatePallbearers(this.leadsUuid, this.selectedPallbearersEvent, 0)
          return response
        } catch (err) {
          return err
        }
      },
      async selectClosingCrew () {
        try {
          const response = await schedulesAPI.updatePallbearers(this.leadsUuid, this.selectedPallbearersClosing, 1)
          return response
        } catch (err) {
          return err
        }
      },
      async approveCase () {
        try {
          const response = await this.$store.dispatch('approveCase', this.getEditCrewCaseId)
          return response
        } catch (err) {
          return err
        }
      },
      async getCaseInvoices () {
        try {
          const response = await this.$store.dispatch('getCaseInvoices', this.getEditCrewCaseId)
          return response
        } catch (err) {
          return err
        }
      },
      async selectCrew (approve = false) {
        const updateEventCrew = await this.selectEventCrew()
        const updateClosingCrew = await this.selectClosingCrew()

        let approveCase = false
        let getInvoices = false

        if (approve) {
          approveCase = await this.approveCase()
          getInvoices = await this.getCaseInvoices()
        } else {
          approveCase = true
          getInvoices = true
        }

        if (updateEventCrew && updateClosingCrew && approveCase && getInvoices) {
          setTimeout(() => {
            this.$store.dispatch('loadAllCases')
          }, 5000)
          this.$store.commit('switchCrewDialog')
        }
      },
      submit () {
        if (this.approved) {
          this.selectCrew(true)
        } else {
          this.selectCrew(false)
        }
      }
    },
    created () {}
  }
</script>



// WEBPACK FOOTER //
// CrewDialog.vue?5263f2ca